import React from "react";
import styles from "./style.module.scss";
import logo from "../../../../assets/images/mashie-shield-with-text-white.png";
import DeprecatedBanner from "./utils/DeprecatedBanner";
import APIVersionDropdown from "./utils/APIVersionDropdown";
import SectionDropdown from "./utils/SectionDropdown";
import EndpointsList from "./utils/EndpointsList";
import Endpoints from "./utils/Endpoints";
import GETClubs from "./clubs/GETClubs.json";
import GETClubsId from "./clubs/GETClubsId.json";
import GETClubsIdSummary from "./clubs/GETClubsIdSummary.json";

const specs = [GETClubs, GETClubsId, GETClubsIdSummary];

export default function Index() {
    return (
        <div className='app events' style={{ paddingBottom: "100px" }}>
            <div className={styles.fullHeader} alt='event'>
                <img className={styles.entityLogo} src={logo} alt='logo' />
                <h1 className={styles.headerText}>
                    Golf Clubs Documentation (v2)
                </h1>
            </div>
            <div className='container'>
                <APIVersionDropdown version='v2' />
                <SectionDropdown page='clubs' />
                <div className='row'>
                    <div className='col-12'>
                        <h2>About this API</h2>
                        <p>
                            This API allows you to find golf clubs and their
                            details, including some information about their
                            courses. These endpoints essentially allow you to
                            get the data in various formats depending on the
                            usecase.
                        </p>
                        <div className={styles.spacer} />

                        <h2>Major updates since v1</h2>
                        <p>
                            <strong>NEW DATA</strong> - Golf clubs have new
                            restrictions on the number of players that can be
                            booked.
                            <ul>
                                <li>bookingCashMinPlayers</li>
                                <li>bookingCashMaxPlayers</li>
                            </ul>
                        </p>
                        <p>
                            <strong>DATA CHANGE</strong> - Golf clubs courses
                            have an entirely new pricing schema. Historically,
                            we only provided prices for summer and winter,
                            monday to sunday, with am and pm for the type of
                            member passed in. We now provide pricing information
                            for each month of the year, each day of the week,
                            every hour of the day, for the type of member passed
                            in. This gives significantly better pricing
                            flexibility for an entire year.
                            <ul>
                                <li>
                                    OLD: [summer/winter] &gt;
                                    [monday/tuesday/wednesday/thursday/friday/saturday/sunday]
                                    &gt; [am/pm]
                                </li>
                                <li>
                                    NEW: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ,11, 12]
                                    &gt; [1, 2, 3, 4, 5, 6, 7] &gt; [0, 1, 2, 3,
                                    4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
                                    16, 17, 18, 19, 20, 21, 22, 23]
                                </li>
                            </ul>
                        </p>
                        <p>
                            <strong>DATA CHANGE</strong> - Due to the change in
                            pricing structure, and new complexity of the data,
                            we have removed some helper data from the club's
                            courses relating to snapshot pricing and poa
                            information. This is due to the fact we now offer
                            monthly, daily, hourly pricing; meaning the snapshot
                            information is may no longer be relevant when
                            displaying over longer periods of time. If you still
                            wish to get this information, you can do so by doing
                            an availability or quote endpoint call which will
                            return daily pricing or a specific hour price as you
                            require.
                        </p>
                    </div>
                    <div className='col-12'>
                        <div className={styles.spacer} />
                        <h2>Endpoints</h2>
                        <EndpointsList specs={specs} />
                        <div className={styles.spacer} />
                        <Endpoints specs={specs} />
                    </div>
                </div>
            </div>
            <DeprecatedBanner version='v2' />
        </div>
    );
}
